import axios from './axios';

const ServiceApi = {
    getByLocale: (locale) => axios.get(`/services/${locale}`),
    create: (formData) =>
        axios.post('/services', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    update: (id, data) => axios.put(`/services/${id}`, data),
    remove: (id) => axios.delete(`/services/${id}`),
};

export default ServiceApi;
